export default __webpack_public_path__ + "static/media/missile-icon.c7eca435.svg";